import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgListSelectComponent } from './pg-list-select.component';
import { PgListSelectItemComponent } from './pg-list-select-item/pg-list-select-item.component';
import { PgIconModule } from '../pg-icon/pg-icon.module';
import { PgListSelectFactoryComponent } from './pg-list-select-factory/pg-list-select-factory.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, PgIconModule, ReactiveFormsModule],
  declarations: [
    PgListSelectComponent,
    PgListSelectItemComponent,
    PgListSelectFactoryComponent,
  ],
  exports: [
    PgListSelectComponent,
    PgListSelectItemComponent,
    PgListSelectFactoryComponent,
  ],
})
export class PgListSelectModule {}
